"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONRPC = exports.JSONRPCMethodError = exports.isSuccess = exports.isError = void 0;
const tslib_1 = require("tslib");
const errors_1 = require("./errors");
function isError(result) {
    return result instanceof Error;
}
exports.isError = isError;
function isSuccess(result) {
    return !isError(result);
}
exports.isSuccess = isSuccess;
class JSONRPCMethodError extends errors_1.HTTPError {
    constructor(error, response) {
        super(error.reason, response);
        this.response = response;
        this.name = "JSON RPC Error";
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, JSONRPCMethodError);
        }
    }
    toJSON() {
        return Object.assign(Object.assign({}, super.toJSON()), { error: this.response.data.error });
    }
}
exports.JSONRPCMethodError = JSONRPCMethodError;
class JSONRPC {
    constructor(conn) {
        this.conn = conn;
        this.version = "2.0";
    }
    invoke(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = Object.assign(Object.assign({}, request), { id: "1", jsonrpc: this.version });
            // const label = `JSONRPC Request method=${request.method}`;
            // TODO: moving timing into connection, proxy common methods from there.
            // console.time(label);
            return yield this.conn.http.post("", data);
        });
    }
    ensure(method, params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.invoke({ method, params });
            const { data } = response;
            if (data.error) {
                throw new JSONRPCMethodError(data.error, response);
            }
            if (data.result === undefined) {
                throw new errors_1.HTTPError("Invalid JSONRPC", response);
            }
            return data.result;
        });
    }
}
exports.JSONRPC = JSONRPC;
//# sourceMappingURL=jsonrpc.js.map